import React, { useEffect, useState } from 'react';
import '../Teacher/printStyles.css'; 
import Barcode from 'react-barcode';
import { useDispatch, useSelector } from 'react-redux';
import { readSchools } from '../../../store/actions/schoolActions';
import { fetchLogo } from '../../../store/actions/logoActions';
import './globalStyles.css';

const TuitionFeeReceipt = React.forwardRef((props, ref) => {

    const { selectedData  } = props;

    const dispatch = useDispatch();
    const { schools, loading, error } = useSelector((state) => state.schoolDetails);  
    const { logoUrl } = useSelector((state) => state.logo);

    // State to track if the image has loaded
    const [imageLoaded, setImageLoaded] = useState(false);

    console.log(selectedData);

     // Fetch the logo on component mount
    useEffect(() => {
      dispatch(readSchools());
      dispatch(fetchLogo());
    }, [dispatch]);

    const handleImageLoad = () => {
      setImageLoaded(true);  // Set the imageLoaded to true when the logo is loaded
      // triggerPrint();        // Trigger the print action once the logo is loaded
    };
  
  
    const barcodeImage = <Barcode value={selectedData.suid} width={0.97} height={35} />; 

     //get current date
  const today = new Date();
  const currentDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
  const startYear = today.getFullYear();
  const endYear = startYear + 1;
  const session = `${startYear}-${endYear}`;

  const [receiptData, setReceiptData] = useState({
    schoolName: schools[0].school_name,
   schoolAddress: `${schools[0].school_address + '  ' + ' ' +schools[0].city + ' ' + schools[0].district + ',' + schools[0].state+ ' , ' + schools[0].postal_code}`,
    //schoolAddress: 'schoolAddress',
    email: schools[0].email_address,
    contactInfo: schools[0].contact_number,
    website_url: schools[0].website_url,
    receiptNumber: selectedData.pay_id,
    date: selectedData.app_date,
    paymentMode: "Cash",
    studentName: selectedData.s_name,
    studentID: selectedData.suid,
    studentClass: selectedData.grade,
    rollNo: selectedData.s_roll,
    feeMonth: '',
    tuitionFee: '',
    otherFees: '',
    totalPaid: selectedData.paid,
    outstandingBalance: selectedData.balance_amt,
    // receivedBy: "Jane Smith",
    billNo:selectedData.pay_id,
  });

  const formattedReceiptNumber = receiptData.receiptNumber.toString().padStart(3, '0');

  return (
    <div ref={ref} className="receipt-container" style={styles.receiptContainer}>
        {/* Watermark */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          opacity: 0.1, // Controls the transparency of the watermark
          zIndex: 0,
        }}>
          <img src={logoUrl} alt='Logo Watermark' style={{ width: '500px', height: '500px' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {/* Left Column: School Logo */}
          <img
            src={logoUrl}
            alt="School Logo"
            onLoad={handleImageLoad}   // Detect when the image is fully loaded
            onError={() => console.error("Logo failed to load")}
            style={{ maxWidth: '100px' }}
          />

          {/* Center Column: School Details */}
          <div style={{ textAlign: 'center', flex: 1 }}>
            <h2 style={{ marginBottom: '5px' }}>{receiptData.schoolName}</h2>
            <p style={{ marginBottom: '3px' }}>Address: {receiptData.schoolAddress}</p>
            <p>Contact: {receiptData.contactInfo}</p>
          </div>

          {/* Right Column: Bill Number */}
          <div style={{ textAlign: 'right' }}>
            <p><strong>Payment ID.:</strong> {formattedReceiptNumber}</p>
          </div>
        </div>


      <div style={styles.content}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Fee Payment Receipt: (Printed on Date: {currentDate})</h3>
          <div>
            {barcodeImage}
          </div>
        </div>

        <table style={styles.table}>
          <tbody>
            <tr>
              <td><strong>Receipt No.:</strong></td>
              <td>{session}/{formattedReceiptNumber}</td>
            </tr>
            <tr>
              <td><strong>Date of payement:</strong></td>
              <td>{receiptData.date}</td>
            </tr>
            <tr>
              <td><strong>Mode of Payment:</strong></td>
              <td>{receiptData.paymentMode}</td>
            </tr>
          </tbody>
        </table>

        <h4>Student Information</h4>
        <table style={styles.table}>
          <tbody>
            <tr>
              <td><strong>Student Name:</strong></td>
              <td>{receiptData.studentName}</td>
            </tr>
            <tr>
              <td><strong>Unique ID:</strong></td>
              <td>{receiptData.studentID}</td>
            </tr>
            <tr>
              <td><strong>Class:</strong></td>
              <td>{receiptData.studentClass}</td>
            </tr>
            <tr>
              <td><strong>Roll No.:</strong></td>
              <td>{receiptData.rollNo}</td>
            </tr>
          </tbody>
        </table>

        <h4>Payment Details</h4>
        <table style={styles.table}>
          <tbody>
            <tr>
              <td><strong>Monthly Fee upto:</strong></td>
              <td>{receiptData.feeMonth}</td>
            </tr>
            <tr>
              <td><strong>Tuition Fee:</strong></td>
              <td>{receiptData.tuitionFee}</td>
            </tr>
            <tr>
              <td><strong>Other Fees:</strong></td>
              <td>{receiptData.otherFees}</td>
            </tr>
            <tr>
              <td><strong>Amount Paid:</strong></td>
              <td>{receiptData.totalPaid}</td>
            </tr>
            <tr>
              <td><strong>Outstanding Balance:</strong></td>
              <td>{receiptData.outstandingBalance}</td>
            </tr>
          </tbody>
        </table>

        <div style={styles.signature}>
          {/* <strong>Received by:</strong> {receiptData.receivedBy}
          <br /> */}
          <br />
          <strong>Signature:</strong> ___________________________
          <br />
          <br />
          <strong>Date:</strong> {receiptData.date}
        </div>
      </div>

      <div style={styles.footer}>
        <p>{receiptData.schoolName} - Official Receipt</p>
        <p>Website:{receiptData.website_url}</p>
      </div>
    </div>
  );
});

// Styles
const styles = {
  receiptContainer: {
    width: '100%',          // Full width of the parent container
    maxWidth: '1200px',      // Optional: set a max width for larger screens
    margin: '0 auto',        // Center the container
    border: '1px solid #000',
    padding: '40px',
    fontFamily: 'Arial, sans-serif'
  },
  header: {
    textAlign: 'center'
  },
  content: {
    marginTop: '20px'
  },
  table: {
    width: '100%',
    marginTop: '20px',
    marginBottom: '10px'
  },
  signature: {
    marginTop: '40px'
  },
  footer: {
    textAlign: 'center',
    marginTop: '20px'
  }
};

export default TuitionFeeReceipt
